import { render, staticRenderFns } from "./NotificationContent.vue?vue&type=template&id=361f4fd3&scoped=true"
import script from "./NotificationContent.vue?vue&type=script&lang=js"
export * from "./NotificationContent.vue?vue&type=script&lang=js"
import style0 from "./NotificationContent.vue?vue&type=style&index=0&id=361f4fd3&prod&lang=scss&scoped=true"
import style1 from "./NotificationContent.vue?vue&type=style&index=1&id=361f4fd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361f4fd3",
  null
  
)

export default component.exports